import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import networksConfig from '../configs/networks-config';

import NetworkReport from './NetworkReport';

import * as filtersActions from '../../actions/filters-actions';
import * as networkActions from '../../actions/network-actions';
import * as queryActions from '../../actions/query-actions';

import {
  getFiltersForNetwork,
  getNetwork
} from '../../reducers/network-reducer';
import { getInlineQueryResults } from '../../reducers/query-reducer';
import { getLooks } from '../../reducers/embed-reducer';

const mapStateToProps = (state, ownProps) => ({
  filters: getFiltersForNetwork(ownProps.match.params.networkId, state),
  looks: getLooks(networksConfig.NETWORK_REPORT_FILTERS.looks, state),
  network: getNetwork(ownProps.match.params.networkId, state),
  queries: getInlineQueryResults(
    networksConfig.NETWORK_REPORT_FILTERS.queries,
    state
  )
});

const mapDispatchToProps = dispatch => ({
  fetchNetwork: networkId => dispatch(networkActions.getNetworkData(networkId)),
  filtersActions: bindActionCreators(filtersActions, dispatch),
  queryActions: bindActionCreators(queryActions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(NetworkReport);
